import React, { useEffect, useState } from "react";
import "../../styles/BlogPageStyle/blogsStyle.css";
// import "../../styles/BlogPageStyle/blogsStyle.css";
import CommonHeaderComp from "../../utils/CommonHeaderComp";
import sotryImg1 from "../../assets/BannerImg/banner3.png";
import sotryImg2 from "../../assets/BannerImg/banner2.png";
import img1Toppings from "../../assets/StoryPage/img1Toppings.png";
import img2Toppings from "../../assets/StoryPage/Img2Toppings.png";
import Aos from "aos";
import blogpageImg2 from "../../assets/BlogPage/blogsDetailsImg2.jpeg";
import blogImg1 from "../../assets/BlogPage/blogImg1.png";
import blogImg2 from "../../assets/BlogPage/blogImg2.png";
import blogImg3 from "../../assets/BlogPage/blogImg3.png";
import blogsCust from "../../assets/BlogPage/blogsCust.png";
import Footer from "../Footer";
import OrderBtn from "../../utils/OrderBtn";
import axios from "axios";
import config from "../../config";
import { Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import Loader from "../../utils/Loader";
import { Helmet } from "react-helmet";

const BlogDetails = () => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [blogData, setBlogData] = useState(false);
  const [current_location_id, setCurrentLocationId] = useState("");
  const [bannerImg1, setBannerImg1] = useState("");
  const [bannerImg2, setBannerImg2] = useState("");
  const [data, setData] = useState("");
  const [recentBlogs, setRecentBlogs] = useState([]);
  const locationPath = useLocation();

  useEffect(() => {
    const storedLocation = localStorage.getItem("location");

    if (storedLocation) {
      setCurrentLocationId(storedLocation);
    }
  }, []);

  useEffect(() => {
    if (current_location_id) {
      getBlogDetails();
      fetchBlogsImages();
    }
  }, [current_location_id, locationPath.pathname]);

  const getBlogDetails = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", current_location_id);

    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/blog/${slug}`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setData(res.data.data);
        setBlogData(res.data.data);
        setRecentBlogs(
          res.data.data.recent.filter((item) => item.approved == 1).slice(0, 3),
        );
        // console.log("blogs data", res.data.data);
        // console.log(
        //   "Recent blog",
        //   res.data.data.recent.filter((item) => item.approved == 1).slice(0, 3)
        // );
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      console.log("Blog Details", error);
    }
  };

  const fetchBlogsImages = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", current_location_id);
    // console.log("Fetching blogs for location:", current_location_id);
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/posts`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setBannerImg1(res.data?.banner_image?.image);
        setBannerImg2(res.data?.banner_image?.image2);
        setIsLoading(false);
      });
    } catch (error) {
      console.log("fetch blogs", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* <Helmet>
        <title>{data?.meta_title}</title>
        <meta name="description" content={data?.meta_description} />
      </Helmet> */}
      <Helmet>
        <title>
          {data?.meta_title
            ? data.meta_title
            : "Enjoy Yummy Ice Cream And Desserts Blog | Rollz Ice Cream"}
        </title>

        <meta
          name="description"
          content={
            data?.meta_description
              ? data.meta_description
              : "Discover a treasure trove of blog content covering ice cream recipe, what is and how to make cheesecake, and much more."
          }
        />

        <meta
          property="og:title"
          content={
            data?.meta_title
              ? data.meta_title
              : "Enjoy Yummy Ice Cream And Desserts Blog | Rollz Ice Cream"
          }
        />

        <meta
          property="og:description"
          content={
            data?.meta_description
              ? data.meta_description
              : "Discover a treasure trove of blog content covering ice cream recipe, what is and how to make cheesecake, and much more."
          }
        />
        <meta
          name="keywords"
          content={
            data?.meta_keywords
              ? data.meta_keywords
              : "ice cream, desserts, cheesecake, recipes, Rollz Ice Cream"
          }
        />
      </Helmet>
      {isLoading && <Loader />}
      <div className="blog_details_page">
        <CommonHeaderComp
          Heading="Read More"
          height="60vh"
          pageName="Read Blog"
          // color="white"
        />

        {/* Image 1  */}
        <div className="position-absolute storyImg1" data-aos="fade-left">
          <img
            src={bannerImg1}
            className="img-fluid img1"
            alt="our story img 1"
            loading="lazy"
          ></img>
        </div>

        {/* Image 2  */}
        <div className="position-absolute storyImg2" data-aos="fade-rigth">
          <img
            src={bannerImg2}
            className="img-fluid img2"
            alt="our story img 2"
            loading="lazy"
          ></img>
        </div>

        {/* Blog details  */}
        <div className="blogPage_container">
          <div className="blogsPage_wrapper">
            <div className="d-flex flex-column blogPage_img">
              <img
                src={blogData?.post_img}
                alt="Blog Image"
                loading="lazy"
              ></img>
            </div>

            <div className="blogPage_details">
              <div className="blogsPage_heading">
                <h5 className="mb-3">Date : {blogData.publish_date ? moment(blogData?.publish_date).format("DD MMM YYYY") : "-"}</h5>
                <h2>{blogData?.post_title}</h2>
                {/* <h2>
                From Vegan Drinks to Cheesecake Ice Cream: Exploring
                Irresistible Dessert Trends You Can’t Miss
              </h2> */}

                {/* <p>
                When it comes to desserts, there’s always something new and
                exciting to discover. At Rollz Ice Cream, we’re all about
                redefining how you indulge in sweets. From vegan drinks to
                cheesecake ice cream, we’ve got something for everyone. Let’s
                dive into the world of delightful dessert trends and explore how
                Rollz Ice Cream can make your cravings come true.
              </p> */}
              </div>

              <div className="col-12 d-flex flex-column flex-md-row align-items-start justify-content-start blogPage_content">
                <div className="col-12 col-md-5 d-flex flex-column align-items-center justify-content-center blogPage_content_img me-0 me-md-5">
                  <img
                    src={blogpageImg2}
                    className="img-fluid"
                    alt="Blog Image"
                    loading="lazy"
                  ></img>

                  <div className="col-12 d-flex flex-column flex-md-row align-items-center justify-content-center blogPage_happyCust">
                    <div className="col-12 col-md-6 text-center  blogPage_happyCust_rating mb-2 mb-md-0">
                      <h5 className="mb-1">Happy Customer</h5>
                      <p>
                        (12k+ Reviews) 4.8 <i className="bi bi-star-fill"></i>
                      </p>
                    </div>
                    {/* <div className="col-12 col-md-6 blogPage_happyCust_img">
                      <img
                        src={blogsCust}
                        className="img-fluid"
                        loading="lazy"
                      ></img>
                    </div> */}
                  </div>
                </div>
                <div className="col-12 col-md-7 blogPage_content_details">
                  <p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: blogData?.post_content,
                      }}
                    ></div>
                    {/* {blogData?.post_content	} */}
                  </p>

                  {/* <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">
                    Satisfy Your Sweet Tooth with Ice Cream Pints and Cakes
                  </h3>
                  <p>
                    There’s nothing quite like enjoying a creamy, dreamy dessert
                    at home. Our ice cream pints are perfect for those cozy
                    nights when you need a sweet companion. If you’re
                    celebrating a special occasion, an ice cream cake is the
                    ultimate crowd-pleaser. Wondering where to find one? Just
                    search for ice cream cake near me and discover Rollz Ice
                    Cream’s irresistible options.
                  </p>
                </div>

                <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">Vegan Drinks: Guilt-Free Indulgence</h3>
                  <p>
                    Veganism is no longer a trend—it’s a lifestyle. At Rollz Ice
                    Cream, we cater to everyone with our range of vegan drinks.
                    Whether you’re after a refreshing smoothie or a creamy vegan
                    milkshake, we’ve got options that are as delicious as they
                    are guilt-free. It’s the perfect choice for those looking to
                    indulge while staying mindful of their dietary choices.
                  </p>
                </div>

                <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">
                    Popping Soda Near Me: A Fizzy Delight
                  </h3>
                  <p>
                    Looking for something refreshing and fun? Our popping soda
                    options are a burst of flavor and excitement. If you’ve ever
                    searched for popping soda near me, Rollz Ice Cream is your
                    one-stop destination for this fizzy treat. Pair it with one
                    of our desserts for the ultimate experience.
                  </p>
                </div>

                <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">Milkshakes That Make Your Heart Melt</h3>
                  <p>
                    Who doesn’t love a classic milkshake? At Rollz, we take it
                    up a notch with our ice cream milkshakes that come in a
                    variety of exciting milkshake flavours. From chocolatey
                    delights to fruity blends, there’s something for everyone.
                    Wondering where to find the best milkshakes? Search shakes
                    near me, and you’ll see why Rollz Ice Cream is the top
                    choice.
                  </p>
                </div>

                <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">Waffles: A Golden Delight</h3>
                  <p>
                    Nothing beats the warmth and crispiness of freshly made
                    waffles. Whether you’re enjoying them as a breakfast treat
                    or a dessert, our waffles are crafted to perfection. Pair
                    them with a scoop of ice cream or drizzle them with syrup
                    for a heavenly experience.
                  </p>
                </div>

                <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">Cheesecake and Beyond </h3>
                  <p>
                    Cheesecake lovers, rejoice! At Rollz Ice Cream, we offer a
                    variety of cheesecakes to satisfy your cravings. From
                    classic cheesecake recipes to unique creations like
                    cheesecake ice cream, we’ve got it all. If you’re wondering,
                    "What is cheesecake?" or "How to make cheesecake?"—it’s time
                    to skip the effort and indulge in our expertly crafted
                    treats. Searching for "cheesecake near me" or "best
                    cheesecake near me" will lead you straight to our delicious
                    offerings.
                  </p>
                </div>

                <div className="blogPage_content_info mb-4">
                  <h3 className="mb-2">Kulfi Near Me: A Taste of Tradition</h3>
                  <p>
                    For those craving something traditional, our kulfi is the
                    perfect choice. This rich and creamy Indian dessert brings a
                    taste of heritage to your table. A quick search for Kulfi
                    near me will guide you to Rollz Ice Cream’s authentic and
                    flavorful options.
                  </p>
                </div> */}

                  <div className="blogPage_orderBTN">
                    <OrderBtn text="Visit To Our Menu Page" url="/menu" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Rcent Blogs  */}
        <div className="recent_blogs_container">
          <div className="recent_blogs_wrapper">
            <h2 className="text-center mb-4">Recent Blogs</h2>
            <div className="column-gap-5 d-flex flex-wrap row-gap-sm-5 align-items-start justify-content-center recent_blogs">
              {recentBlogs.map((item) => {
                const evenBlog = item.id % 2 === 0;
                const colors = ["#fd85b2", "#eac76f", "#a8a3d8"];
                const bgColor = colors[item.id % colors.length];
                return (
                  <div
                    className={`single_blog mb-5 mb-md-0  d-flex justify-space-between align-items-start  ${
                      evenBlog ? "flex-column-reverse" : "flex-column"
                    }`}
                    key={item.id}
                    style={{ backgroundColor: bgColor }}
                  >
                    <div className="blog_img">
                      <img
                        src={item?.post_img}
                        className="img-fluid"
                        loading="lazy"
                      ></img>
                    </div>
                    <div className="blog_content">
                      <h6 className="blog_date mb-3">
                        {moment(item?.created_at).format("DD MMM yy")}
                      </h6>
                      <Link to={`${config.appUrl}/blog-details/${item?.slug}`}>
                        <h3 className="blog_title mb-3">{item?.post_title}</h3>
                      </Link>
                      <div>
                        <p className="blog_para">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.post_content.slice(0, 150),
                            }}
                          ></div>
                        </p>
                      </div>
                      {/* <OrderBtn
                      text="Read More"
                      url="blog-details"
                      width="fit-content"
                    /> */}
                      <div className="order-online">
                        <Link
                          className="blue-btn hero-anchor"
                          to={`${config.appUrl}/blog-details/${item?.slug}`}
                          onClick={() => window.reload()}
                        >
                          <div className="order-online-trans-1"></div>
                          <div className="order-online-trans-2"></div>
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* <Footer color="#ffecf0" /> */}
      </div>
    </>
  );
};

export default BlogDetails;
